import styled, { keyframes } from 'styled-components';
import { colours, media, spacing, zAutocomplete, zAutocompleteOverlay, zStickyHeader } from '../../../stylings';

const showNavBar = keyframes`
  to {
    top: 0;
  }
`;

const hideNavBar = keyframes`
  from {
    top: 0;
  }

  to {
    top: -100px;
  }
`;

export const Cart = styled.a`
  align-items: center;
  display: flex;
  height: 24px;
  justify-content: center;
  padding: 2px;
  width: 24px;

  & svg {
    height: 20px;
    width: 20px;

    @media ${media.greaterThan('lg')} {
      height: 20px;
      width: 20px;
    }
  }

  @media ${media.greaterThan('lg')} {
    margin-right: 0;
  }
`;

export const HamburgerButton = styled.button`
  align-items: center;
  background: none;
  border: 0;
  display: flex;
  height: 24px;
  justify-content: center;
  padding: 0;
  width: 24px;

  & svg {
    height: 22px;
    width: 22px;
  }
`;

export const IconsWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: ${spacing.XS};

  & a {
    align-items: center;
    display: flex;
  }

  @media ${media.greaterThan('lg')} {
    gap: ${spacing.S};
  }
`;

export const Logo = styled.div`
  display: flex;
  width: 95px;

  img {
    height: 100%;
    width: 100%;
  }

  & a {
    display: flex;
    height: 100%;
    width: 100%;
  }

  @media ${media.greaterThan('lg')} {
    width: 120px;
  }
`;

export const MyAccount = styled.a`
  align-items: center;
  display: flex;
  height: 24px;
  justify-content: center;
  padding: 2px;
  transition: transform 0.3s ease;
  width: 24px;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }

  & svg {
    height: 20px;
    width: 20px;

    @media ${media.greaterThan('lg')} {
      height: 20px;
      width: 20px;
    }
  }

  &:hover,
  &:focus {
    transform: translateY(-2px);

    .hover-bg {
      background-color: ${colours.LIGHT_BLUE};
    }
  }
`;

export const MyAccountHoverBackground = styled.div`
  border-radius: 50%;
  height: 20px;
  left: 0%;
  position: absolute;
  top: 8%;
  width: 20px;
  z-index: -1;
`;

export const Wrapper = styled.div`
  align-items: center;
  background-color: ${colours.WHITE};
  display: flex;
  flex-direction: row;
  height: 100%;
  justify-content: space-between;
  max-width: 1440px;
  min-height: 60px;
  padding: ${spacing.XS} ${spacing.S};
  position: relative;
  z-index: ${zAutocomplete};

  .sticky & {
    padding-bottom: ${spacing.S};
  }

  @media ${media.greaterThan('lg')} {
    flex-wrap: nowrap;
    height: min-content;
    justify-content: space-between;
    margin: 0 auto;
    min-height: 80px;
    padding: 0 ${spacing.S};
    position: static;

    .sticky & {
      padding-bottom: 0;
    }
  }
  @media ${media.greaterThan('xl')} {
    margin: 0 auto;
    padding: 0 70px;
  }
  @media ${media.greaterThan('xx')} {
    gap: 96px;
  }
`;

export const StickyWrapper = styled.div`
  background-color: ${colours.WHITE};
  z-index: ${zStickyHeader};

  &.sticky {
    left: 0;
    position: fixed;
    right: 0;
    top: -100px;
  }

  &.hide-navbar {
    animation: ${hideNavBar} 0.5s linear forwards;
  }

  &.show-navbar {
    animation: ${showNavBar} 0.5s linear forwards;
  }

  @media screen and (prefers-reduced-motion: reduce) {
    &.hide-navbar {
      animation: none;
      top: -100px;
    }

    &.show-navbar {
      animation: none;
      top: 0;
    }
  }
`;

export const NavBarWrapperContainer = styled.div`
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
  position: relative;
`;

export const Placeholder = styled.div`
  height: 0;

  &.sticky {
    display: block;
    height: 48px;
  }

  @media ${media.greaterThan('lg')} {
    &.sticky {
      height: 80px;
    }
  }
`;

export const CartIconWrapper = styled.div`
  position: relative;
`;

export const SearchIcon = styled.button`
  align-items: center;
  background: none;
  border: 0;
  display: flex;
  height: 24px;
  justify-content: center;
  padding: 0;
  width: 24px;

  & svg {
    height: 20px;
    width: 20px;
  }

  @media ${media.greaterThan('lg')} {
    display: none;
  }
`;

export const SearchOverlay = styled.div`
  background-color: rgba(0, 0, 0, 0.4);
  height: 100vh;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: ${zAutocompleteOverlay};
`;
